import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { Tree } from "antd"
import isEmpty from "lodash/isEmpty"

const { TreeNode } = Tree

import SpinnerLoader from "../../../../../../../components/spinnerloader"

class ShortcutList extends React.PureComponent {
  renderShortcutTreeNode = () => {
    const { cn_loading, cn_group, selected_key, default_expand_all, onSelectTreeNode } = this.props

    if (cn_loading)
      return (
        <div className="ori-pad-5">
          <SpinnerLoader size="small" text="loading" />
        </div>
      )

    if (isEmpty(cn_group))
      return (
        <div className="ori-font-xs ori-font-warning ori-pad-5">Canned response list is empty. please go to canned responses page and add canned responses</div>
      )

    return (
      <Tree className="ori-tree-node-selected-primary" defaultExpandAll={default_expand_all} onSelect={onSelectTreeNode} >
        {
          Object.keys(cn_group).map((cn_item1, index1) => {
            const key1 = `${index1}`
            if (cn_group[cn_item1].messages)
              return (
                <TreeNode
                  className={classNames({ "ori-tree-node-title-primary": selected_key === key1 })}
                  key={key1}
                  title={`#${cn_item1}`}
                  value={cn_group[cn_item1]}
                  leaf
                />
              )
            return (
              <TreeNode
                key={key1}
                title={cn_item1}
                selectable={false}
              >
                {
                  Object.keys(cn_group[cn_item1]).map((cn_item2, index2) => {
                    const key2 = `${index1}-${index2}`
                    if (cn_group[cn_item1][cn_item2].messages)
                      return (
                        <TreeNode
                          className={classNames({ "ori-tree-node-title-primary": selected_key === key2 })}
                          key={key2}
                          title={`#${cn_item2}`}
                          value={cn_group[cn_item1][cn_item2]}
                          leaf
                        />
                      )
                    return (
                      <TreeNode
                        key={key2}
                        title={cn_item2}
                        selectable={false}
                      >
                        {
                          Object.keys(cn_group[cn_item1][cn_item2]).map((cn_item3, index3) => {
                            const key3 = `${index1}-${index2}-${index3}`
                            if (cn_group[cn_item1][cn_item2][cn_item3].messages)
                              return (
                                <TreeNode
                                  className={classNames({ "ori-tree-node-title-primary": selected_key === key3 })}
                                  key={key3}
                                  title={`#${cn_item3}`}
                                  value={cn_group[cn_item1][cn_item2][cn_item3]}
                                  leaf
                                />
                              )
                            return null
                          })
                        }
                      </TreeNode>
                    )
                  })
                }
              </TreeNode>
            )
          })
        }
      </Tree>
    )
  }
  render() {
    return (
      <div
        className="ori-animated ori-fade-in ori-box-shadow ori-bg-white ori-lr-pad-5 ori-overflow-y-auto" style={{
          maxHeight: "460px",
          maxWidth: "300px"
        }}
      >
        {this.renderShortcutTreeNode()}
      </div>
    )
  }
}

ShortcutList.propTypes = {
  cn_loading: PropTypes.bool,
  cn_group: PropTypes.object,
  onSelectTreeNode: PropTypes.func,
  selected_key: PropTypes.string,
  default_expand_all: PropTypes.bool,
}

ShortcutList.defaultProps = {
  cn_group: {},
  default_expand_all: false,
  selected_key: "",
}

export default ShortcutList



// WEBPACK FOOTER //
// ./src/app/pagecontainer/components/chatinterface/components/chatcomposer/shortcutlist/index.js